export default __webpack_public_path__ + "static/media/Comp 2_00021.5c306570.png";